import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3.75C4.48122 3.75 3.25 4.98122 3.25 6.5V17.5C3.25 19.0188 4.48122 20.25 6 20.25H8C9.51878 20.25 10.75 19.0188 10.75 17.5V6.5C10.75 4.98122 9.51878 3.75 8 3.75H6ZM4.75 6.5C4.75 5.80964 5.30964 5.25 6 5.25H8C8.69036 5.25 9.25 5.80964 9.25 6.5V17.5C9.25 18.1904 8.69036 18.75 8 18.75H6C5.30964 18.75 4.75 18.1904 4.75 17.5V6.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 3.75C14.4812 3.75 13.25 4.98122 13.25 6.5V17.5C13.25 19.0188 14.4812 20.25 16 20.25H18C19.5188 20.25 20.75 19.0188 20.75 17.5V6.5C20.75 4.98122 19.5188 3.75 18 3.75H16ZM14.75 6.5C14.75 5.80964 15.3096 5.25 16 5.25H18C18.6904 5.25 19.25 5.80964 19.25 6.5V17.5C19.25 18.1904 18.6904 18.75 18 18.75H16C15.3096 18.75 14.75 18.1904 14.75 17.5V6.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconPause as ReactComponent };
